<template>
    <div :style="{'min-height':minHeight}"  style="width:100%;background-color:rgba(0, 0, 0, 0.05);display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <div style="width:500px;padding:0px 10px;background-color: #fff;font-size: 14px;box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);border-radius: 3px;">
            <el-row style="height: 50px;color:#c40001;font-weight: 700;line-height: 50px;border-bottom: 2px dotted #2d8cf0;">
                重置密码
            </el-row>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm" style="padding: 0 30px 0 20px;">
                <el-form-item 
                    style="margin-top:40px;"
                    label="原密码" 
                    label-width="90px"
                    prop="oldPassword"
                >
                    <el-input placeholder="请输入密码" autocomplete="off"  v-model="ruleForm.oldPassword" show-password clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;"
                    label="新密码" 
                    label-width="90px"
                    prop="password"
                >
                    <el-input placeholder="请输入密码" autocomplete="off"  v-model="ruleForm.password" show-password clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;"
                    label="确认密码" 
                    label-width="90px"
                    prop="checkPassword"
                >
                    <el-input placeholder="请输入密码" autocomplete="off" v-model="ruleForm.checkPassword" show-password clearable></el-input>
                </el-form-item>

                <el-form-item 
                    style="margin-top:40px;position: relative;"
                    label="验证码" 
                    label-width="90px"
                    prop="vifyCode"
                >
                    <el-input style="width:200px;" placeholder="请输入验证码" v-model="ruleForm.vifyCode" clearable></el-input>
                    <img @click="getVierificationCode" width="100" :src="codeImgSrc" style="position: absolute;right:40px;top:5px;width:100px;height:30px;display:inline-block;cursor: pointer;">
                </el-form-item>

                <el-form-item label-width="0" style="margin-top:40px;display: flex;justify-content: center;align-items: center;">
                    <el-button style="width:200px;background-color: #c40001;border-color:#c40001;" type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default{
        name:'ResetPassword',
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请输入密码'));
                } else {
                if (this.ruleForm.checkPassword !== '') {
                    this.$refs.ruleForm.validateField('checkPassword');
                }
                callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
                } else {
                callback();
                }
            };
            return{
                ruleForm: {
                    oldPassword: '',
                    password:'',
                    checkPassword:'',
                    vifyCode:'',
                },
                uuid:'',                
                rules: {
                    oldPassword: [
                            { required: true, message: '请输入原密码', trigger: 'blur' },
                        ],
                        password: [
                            { validator: validatePass,required: true, trigger: 'blur' }
                        ],
                        checkPassword: [
                            { validator: validatePass2,required: true, trigger: 'blur' }
                        ],                       

                        vifyCode: [
                            { required: true, message: '请输入验证码', trigger: 'blur' },
                        ],

                },
                minHeight:'100%',
                codeImgSrc:'',
            }
        },
        methods:{
            submitForm:function(formName) {
                var that=this;
                this.$refs[formName].validate((valid) => {
                if (valid) {
                        //注册 调用API
                        var arr = [];
                        var jsont = { "uuid": this.uuid, "ruleForm": this.ruleForm};
                        arr.push(jsont);

                        this.$axios.post(
                            this.Global.globalUrl+'/interface/resetPassword.ashx',
                            JSON.stringify(arr),
                            {
                                //header: { 'content-type': 'application/x-www-form-urlencoded' }
                                headers:{
                                    'token':JSON.stringify(this.getToken())
                                }

                            })
                        .then((res) => {
                            if (res.data.err==0){
                                this.$message({
                                    showClose:true,
                                    duration:5000,
                                    type: 'success',
                                    message: '重置成功!'
                                });
                                //路由到登录
                                this.$router.push({name: "JobEdit"});  
                            }else{
                                this.$message({
                                    showClose:true,
                                    duration:5000,
                                    type: 'error',
                                    message: res.data.errMsg
                                });
                            }
                        })
                        .catch(() => {
                        })

                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            getVierificationCode:function(){
                var that=this;
                this.$axios.get(this.Global.globalUrl+'/interface/getVierifyCode.ashx',
                    {
                        headers:{
                            'token':JSON.stringify(this.getToken())
                        }
                    }
                )
                .then((res) => {
                    if (res.data.err==0){
                    that.uuid = res.data.uuid; 
                    that.codeImgSrc = "data:image/png;base64," + res.data.img;                             
                    }else{
                        this.$message({                                   
                            duration:5000,
                            type: 'error',
                            message: res.data.errMsg
                        });
                    }
                })
                .catch(() => {
                })
            },
        },
        mounted(){
            this.$nextTick(function () {
                this.minHeight = (document.documentElement.clientHeight -200)+'px';
                this.getVierificationCode();
            })
        }
    }
</script>